import React from 'react';
import CarouselArrows from './components/CarouselArrows';
import ItemsList from './components/ItemsList';
import { Container, StyledCarousel } from './ContentItemCarousel.styles';
import classNames from 'classnames';

export const CARD_TYPE = {
    CONTENT_ITEM: 'CONTENT_ITEM',
    SHOWCASE: 'SHOWCASE',
    PROMOTION: 'PROMOTION',
};

export function slugify(text) {
    const slug = encodeURIComponent(
        text
            .toString()
            .toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w-]+/g, '') // Remove all non-word chars
            .replace(/--+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, '')
    ); // Trim - from end of text

    return `id-${slug}`;
}

const ContentItemCarousel = (props) => {
    const { id = '', presentation, cardType, className, dataRt, index } = props;
    const carouselId = slugify(`core-carousel-${id}`);

    // do not add lp_classes to displaywindow-components
    const classes = classNames(className, { [`lp_${id}`]: !id.includes('recommended') });
    const carouselClass = id.includes('recommended') ? '' : `lp_list${index}` || '';

    return (
        <Container className={classes} data-rt={dataRt}>
            <>
                <CarouselArrows carouselId={carouselId} presentation={presentation} cardType={cardType} />
                <div
                    style={{
                        overflow: 'hidden',
                        position: 'relative',
                    }}
                >
                    <StyledCarousel id={carouselId} className={carouselClass} friction={0.8}>
                        <ItemsList {...props} />
                    </StyledCarousel>
                </div>
            </>
        </Container>
    );
};

export default ContentItemCarousel;
